import myFooter from './Footer'

const footers = {
  install: (Vue) => {
    Vue.component('Footer', myFooter)
  }
}

export default footers



// WEBPACK FOOTER //
// ./src/components/footer/index.js